module.exports = __webpack_public_path__ + "img/unsere_kostbarkeiten.b9371b98.svg";